import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { FiLock, FiLogIn, FiMail, FiActivity, FiShield, FiArrowLeft } from "react-icons/fi";
import { isErrorMonitorAuthed } from "./errorAuth";
import axios from "axios";
import { setCookie } from "../../helper/commonFunction";

const ErrorLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isErrorMonitorAuthed()) {
      navigate("/error-monitor/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter email and password.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${process.env.client_apiEndpoint}/error-monitor-login`, {
        email: email.trim(),
        password: password,
      });
      if (res.data.data.success) {
        setCookie("error_monitor_token", res.data.data.token, 1);
        navigate("/error-monitor/dashboard", { replace: true });
        setLoading(false)
      } else {
        setError("Invalid credentials");
        setLoading(false)
      }
    } catch (err) {
      setError("Invalid credentials");
      setLoading(false)
    }
 
  };

  return (
    <div className="em-login">
        <div className="em-login__card">
          <div className="em-login__cardHeader">
            <div>
              <h1 className="h4 em-title">Sign in to Error Monitor</h1>
              <p className="em-subtitle">Use your admin credentials to continue.</p>
            </div>
            <div className="em-icon">
              <FiLock size={18} />
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="errorEmail" className="hw-label">
                Email
              </label>
              <div style={{ position: "relative" }}>
                <FiMail style={{ position: "absolute", left: 12, top: 13, color: "var(--em-muted)" }} />
                <input
                  id="errorEmail"
                  type="email"
                  className="em-input"
                  style={{ paddingLeft: 36 }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={"Email"}
                />
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="errorPassword" className="hw-label">
                Password
              </label>
              <div style={{ position: "relative" }}>
                <FiLock style={{ position: "absolute", left: 12, top: 13, color: "var(--em-muted)" }} />
                <input
                  id="errorPassword"
                  type="password"
                  className="em-input"
                  style={{ paddingLeft: 36 }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>
            </div>
            {error ? (
              <div className="hw-p-error-cls mb-3">{error}</div>
            ) : null}
            <button
              type="submit"
              className="em-btn em-btn--primary"
              style={{ width: "100%", justifyContent: "center", padding: "10px 12px" }}
              disabled={loading}
            >
              <FiLogIn />
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
  );
};

export default ErrorLogin;

